<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete MIC Type :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/admin/hse-types">
                            MIC Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-edit"></i> Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card" v-if="needs_merge">
                        <h4 class="card-header">Merge and Delete MIC Type</h4>
                        <div class="card-body">
                            <div class="row form-group">
                                <div class="col-12 alert alert-info">You about to merge this MIC type into the selected type below. This will assign all MICs to the type in the dropdown and then delete this MIC type.</div>
                                <select :class="{'is-invalid': errors.reassign_id}" class="form-control" v-model="mergeToId">
                                    <option :value="null">-- Select an MIC Type --</option>
                                    <option v-for="option in hse_types" :value="option.hse_type_id">
                                        {{ option.hse_type_name }}
                                    </option>
                                </select>
                                <span v-if="errors.reassign_id" class="text-danger">
                                    <span v-for="error in errors.reassign_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-success" v-on:click="deleteHseType()" :disabled="saving">Merge and Delete MIC Type</button>
                        </div>
                    </div>
                    <div class="card" v-else>
                        <h4 class="card-header">Delete MIC Type</h4>
                        <div class="card-body">
                            <div class="row form-group">
                                <div class="col-12 alert alert-info">This MIC Type has no MICs assigned to it. No merge is necessary, this MIC Type can simply be deleted.</div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-success" v-on:click="deleteHseType()" :disabled="saving">Delete MIC Type</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                hse_type_id: this.$route.params.id,
                mergeToId: null,
                hse_types: [],
                needs_merge: false,
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getHseTypes: function() {
                //Get the data
                this.$http
                    .get(`admin/hse-types-delete/${this.hse_type_id}`)
                    .then(response => {
                        //Set all the data
                        this.hse_types = response.data.other_hse_types;
                        this.needs_merge = response.data.needs_merge;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteHseType: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                let data = {
                    'delete_id': this.hse_type_id,
                };

                if (this.needs_merge)
                {
                    data['reassign_id'] = this.mergeToId;
                }

                //Send it
                this.$http
                .post('admin/hse-types-delete', data)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('MIC Type Deleted');

                    //Return to main list?
                    this.$router.push('/admin/hse-types');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getHseTypes();
        }
    }
</script>
